/**
 * Board/cards-or-table switch for the CRM pages.
 *
 * It lives in the card header, on the same row as the title and its count,
 * rather than up in the page header — the choice belongs next to the list it
 * controls. Each page keeps its own choice, so the pipeline can stay a board
 * while deals stay a table.
 */
import { useApp } from '../store/AppContext.jsx';
import Icon from '../lib/icons.jsx';

export default function ViewToggle({ view }) {
  const { crmMode, setCrmView } = useApp();
  const current = crmMode[view] || 'grid';

  return (
    <div className="seg">
      <button
        type="button"
        className={current === 'grid' ? 'on' : ''}
        onClick={() => setCrmView(view, 'grid')}
        title={view === 'pipeline' ? 'Board' : 'Cards'}
      >
        <Icon name="grid" />
      </button>
      <button
        type="button"
        className={current === 'list' ? 'on' : ''}
        onClick={() => setCrmView(view, 'list')}
        title="Table"
      >
        <Icon name="list" />
      </button>
    </div>
  );
}
